/* eslint-disable */
export const Config = Object.freeze({
  // Added support for NODE_ENV in vite.config.ts, rest is standard VITE
  NODE_ENV: import.meta.env.NODE_ENV || 'production',
  API_URL: import.meta.env.VITE_API_URL || 'https://api.brenger.nl',
  API_TOKEN: import.meta.env.VITE_API_TOKEN,
  GEO_API_URL: import.meta.env.VITE_GEO_API_URL || 'https://geo.brenger.nl',
  BRENGER_BASE_URL: import.meta.env.VITE_BRENGER_BASE_URL || 'https://www.brenger.nl',
  BRENGER_MAIN_DOMAIN: 'https://www.brenger.nl',
  BRENGER_DRIVER_BASE_URL: import.meta.env.VITE_BRENGER_DRIVER_BASE_URL || 'https://driver.brenger.nl',
  TRANSLATIONS_URL: 'https://api.brenger.nl',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  LOG: import.meta.env.VITE_LOG === 'true',
  TRIGGER_CONSENT_GTM: !!import.meta.env.VITE_GTM_ID,
  PRICE_API_URL: import.meta.env.VITE_PRICE_API_URL || 'https://pricing.brenger.nl',
  ASSETS_PATH: import.meta.env.VITE_ASSETS_PATH,
  TRACKING_BASE_URL: import.meta.env.VITE_TRACKING_BASE_URL || 'https://live.brenger.nl',
  COMMIT_SHA: import.meta.env.VITE_CI_COMMIT_SHA, // Mapped and provided by in .gitlab-ci.yml
  SUPPORTED_LANGUAGES: ['nl', 'en', 'en-nl', 'de-de', 'es-es'],
  USER_DATA_URL: import.meta.env.VITE_USER_DATA_URL || 'https://user-data.brenger.nl',
  TB_AUCTIONS_GRAPHQL_ENDPOINT:
    import.meta.env.VITE_TB_AUCTIONS_GRAPHQL_ENDPOINT || 'https://storefront.tbauctions.com/storefront/graphql',
  HELP_MODAL_HAS_CHAT: false,
});
